import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezionePagamenti } from '../../../models/sezioni/sezione-pagamenti';
import { PagamentiAddComponent } from './pagamenti-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [pagamento-mod-add]',
  templateUrl: 'pagamento-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class PagamentoModAdd {
  @Output() onReturn: EventEmitter<SezionePagamenti> = new EventEmitter<SezionePagamenti>();
  @ViewChild('formPagamentoAdd') formPagamento: PagamentiAddComponent;

  inizializza(idSezione: string, fascicolo: FascicoloFull, urlInsert: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string, urlReadSezioneLegali: string) {
    this.formPagamento.inizializza(idSezione, fascicolo, urlInsert, urlReadSezioneAltreParti, urlReadSezioneControparti, urlReadSezioneLegali);
    openModal('modaladdPagamento');
  }

  createForm() {
    this.formPagamento.setTextEmpty();
    this.formPagamento.createForm();
  }

  manageModal(sezionePagamenti: SezionePagamenti) {
      closeModal('modaladdPagamento');
      this.onReturn.emit(sezionePagamenti);
  }
}
